<template>
  <el-row class="pageSize" style="margin: 0 auto; padding-top: 15px;">

    <Head homeTitle="定性评级"></Head>
    <el-row>
      <el-col :span="1" class="line_border_bottom el-tabs__item">
      </el-col>
      <el-col :span="23">
        <el-tabs v-model="activeName" type="card" @tab-click="ReloadTab">
          <el-tab-pane label="奖牌基金表现" name="first">
            <AnalystRating ref="AnalystRating"></AnalystRating>
          </el-tab-pane>
          <el-tab-pane label="基金报告" name="four">
            <PDFDownload ref="pdfDownload"></PDFDownload>
          </el-tab-pane>
          <el-tab-pane label="评级基金列表" name="second" :disabled="isDisabled()">
            <AnalystRatingFund ref="analystRatingFund"></AnalystRatingFund>
          </el-tab-pane>
          <!-- <el-tab-pane label="方法论" name="third">
            <Methodology ref="methodology"></Methodology>
          </el-tab-pane> -->
        </el-tabs>
      </el-col>
    </el-row>
  </el-row>
</template>
<script>
import AnalystRating from "./AnalystRating";
import AnalystRatingFund from "./AnalystRatingFund";
import PDFDownload from "./PDFDownload"
// const Methodology = require("cb-components-suitability").default.Methodology;
const componentsCommon = require("cb-components-common").default;
const getNameAndValue = componentsCommon.localStorage.getNameAndValue;

let Head = componentsCommon.Head;
export default {
  data() {
    return {
      activeName: "first"
    };
  },
  components: { Head, AnalystRating, AnalystRatingFund, PDFDownload },
  watch: {
    activeName: function (val) {
      let self = this;
      switch (val) {
        case "first":
          break;
        case "second": {
          self.$refs.analystRatingFund.int();
          break;
        }
        // case "third": {
        //   self.$refs.methodology.loadingData(2);
        //   break;
        // }
        case "four": {
          // self.$refs.fundReportDownload.int();
          break;
        }
      }
    },
  },
  methods: {
    ReloadTab(para) {
      let self = this;
      if (para.name == "first") {

      }
    },
    isDisabled() {
      let self = this;
      const roleInfo = getNameAndValue("info");
      let analystPlatinumFlag = null;
      if (roleInfo != undefined && roleInfo != null && roleInfo != "") {
        let role = JSON.parse(roleInfo);
        analystPlatinumFlag = role.analystRatingMemberSeniorTrial || role.analystRatingMemberSenior;
      }
      if (analystPlatinumFlag) {
        return false;
      }
      else {
        return true;
      }
    },
    // isDisabledV2() {
    //   let self = this;
    //   console.log("was checked");
    //   let analystPlatinum = getNameAndValue("analystPlatinum");
    //   if(analystPlatinum) {
    //     return "";
    //   }
    //   else {
    //     return "is-disabled";
    //   }
    // },
    // checkStatus() {
    //   let self = this;
    //   console.log("was clicked");
    //   let analystPlatinum = getNameAndValue("analystPlatinum");
    //   if(!analystPlatinum) {
    //     handleMessage();
    //   }
    // },
    // handleMessage() {
    //     Message({
    //         message:
    //             "服务暂未授权<br>如需开通请联系对应销售人员或chinamarketing@morningstar.com",
    //         dangerouslyUseHTMLString: true,
    //     });
    // },
  },
};
</script>